<template>
  <div v-if="canUpdate || canDelete" class="d-flex align-items-center justify-content-between">
    <div v-if="$wait.waiting('delete-event')" class="d-flex pl-3 py-4">
      <sdui-loader />
    </div>
    <b-button
      v-else-if="canDelete"
      variant="link"
      class="px-0"
      data-cy="event-details-modal-delete-event"
      @click="$emit('delete-event-button-clicked')"
    >
      <div class="d-flex align-items-center">
        <sdui-icon class="icon-delete-o mr-3" />
        <p class="font-weight-normal mb-0">{{ $t('calendar.event_details.delete.title') }}</p>
      </div>
    </b-button>
    <b-button
      v-if="canUpdate"
      id="edit-event-button"
      variant="primary"
      data-cy="event-details-modal-update-event"
      @click="$emit('edit-event-button-clicked')"
    >
      <p class="font-weight-normal mb-0">{{ $t('calendar.event_details.edit') }}</p>
    </b-button>
  </div>
</template>
<script>
import SduiLoader from 'src/components/miscellaneous/ui/common/SduiLoader.vue'

export default {
  name: 'UpdateAndEditEvent',
  components: { SduiLoader },
  props: {
    canDelete: {
      type: Boolean,
      default: false,
    },

    canUpdate: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['delete-event-button-clicked', 'edit-event-button-clicked'],

  methods: {},
}
</script>
